// extracted by mini-css-extract-plugin
export default {"outlet":"users_outlet__BJmtB","title":"users_title__6zyVF"};